import { PascalCaseToCamelCase } from '@approvalmax/types';
import { backend } from 'modules/data';

import {
    airwallexBatchPaymentPurposeMessages,
    airwallexBatchPaymentStatusMessages,
} from './FilterReferenceList.messages';

const airwallexBatchPaymentPurposeToText = ({
    fieldValueId,
    value,
}: PascalCaseToCamelCase<backend.FieldValueAnswer>) => {
    switch (fieldValueId) {
        case 'audio_visual_services':
            return airwallexBatchPaymentPurposeMessages['audio_visual_services'];
        case 'business_expenses':
            return airwallexBatchPaymentPurposeMessages['business_expenses'];
        case 'donation_charitable_contribution':
            return airwallexBatchPaymentPurposeMessages['donation_charitable_contribution'];
        case 'education_training':
            return airwallexBatchPaymentPurposeMessages['education_training'];
        case 'family_support':
            return airwallexBatchPaymentPurposeMessages['family_support'];
        case 'goods_purchased':
            return airwallexBatchPaymentPurposeMessages['goods_purchased'];
        case 'investment_capital':
            return airwallexBatchPaymentPurposeMessages['investment_capital'];
        case 'investment_proceeds':
            return airwallexBatchPaymentPurposeMessages['investment_proceeds'];
        case 'living_expenses':
            return airwallexBatchPaymentPurposeMessages['living_expenses'];
        case 'loan_credit_repayment':
            return airwallexBatchPaymentPurposeMessages['loan_credit_repayment'];
        case 'medical_services':
            return airwallexBatchPaymentPurposeMessages['medical_services'];
        case 'other_services':
            return airwallexBatchPaymentPurposeMessages['other_services'];
        case 'personal_remittance':
            return airwallexBatchPaymentPurposeMessages['personal_remittance'];
        case 'professional_business_services':
            return airwallexBatchPaymentPurposeMessages['professional_business_services'];
        case 'real_estate':
            return airwallexBatchPaymentPurposeMessages['real_estate'];
        case 'technical_services':
            return airwallexBatchPaymentPurposeMessages['technical_services'];
        case 'transfer_to_own_account':
            return airwallexBatchPaymentPurposeMessages['transfer_to_own_account'];
        case 'wages_salary':
            return airwallexBatchPaymentPurposeMessages['wages_salary'];

        default:
            return value;
    }
};

const airwallexBatchPaymentStatusToText = ({
    fieldValueId,
    value,
}: PascalCaseToCamelCase<backend.FieldValueAnswer>) => {
    switch (fieldValueId) {
        case 'Awaiting Payment':
            return airwallexBatchPaymentStatusMessages.awaitingPayment;
        case 'Failed':
            return airwallexBatchPaymentStatusMessages.failed;
        case 'None':
            return airwallexBatchPaymentStatusMessages.none;
        case 'Paid':
            return airwallexBatchPaymentStatusMessages.paid;
        case 'Partially Paid':
            return airwallexBatchPaymentStatusMessages.partiallyPaid;
        case 'Processing':
            return airwallexBatchPaymentStatusMessages.processing;
        default:
            return value;
    }
};

export const normalizeValues = (
    values: PascalCaseToCamelCase<backend.FieldValueAnswer>[],
    systemPurpose: backend.FieldSystemPurpose
) => {
    switch (systemPurpose) {
        case backend.FieldSystemPurpose.AirwallexPaymentPurpose:
            return values.map((value) => ({
                fieldValueId: value.fieldValueId,
                value: airwallexBatchPaymentPurposeToText(value),
            }));
        case backend.FieldSystemPurpose.AirwallexBatchPaymentStatus:
            return values.map((value) => ({
                fieldValueId: value.fieldValueId,
                value: airwallexBatchPaymentStatusToText(value),
            }));
        default:
            return values;
    }
};
